import React from 'react';
import { cn } from 'lib/utils';

export interface SliderProps {
  value: number;
  onChange: (value: number) => void;
  min?: number;
  max?: number;
  step?: number;
  disabled?: boolean;
  id?: string;
  ariaLabel?: string;
  className?: string;
}

/** Native `<input type="range">` (keyboard + a11y + reduced-motion for free), tinted via `accent-color`. */
export const Slider: React.FC<SliderProps> = ({
  value,
  onChange,
  min = 0,
  max = 100,
  step = 1,
  disabled = false,
  id,
  ariaLabel,
  className,
}) => (
  <input
    type="range"
    id={id}
    aria-label={ariaLabel}
    min={min}
    max={max}
    step={step}
    value={value}
    disabled={disabled}
    onChange={(e) => onChange(Number(e.target.value))}
    className={cn(
      'h-1.5 w-full cursor-pointer appearance-none rounded-full bg-muted accent-primary-600',
      'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2',
      'disabled:cursor-not-allowed disabled:opacity-50',
      className,
    )}
  />
);

export default Slider;
